import { onScopeDispose, readonly, ref, type Ref } from 'vue'

/**
 * Reactive flag for the Tailwind `sm` breakpoint — `true` when the
 * viewport is narrower than 640px. Drives mobile-specific UI branches
 * (drawer width, header hamburger) that can't be expressed in pure CSS
 * because they need a JavaScript value (drawer widths, `v-if` splits).
 *
 * Uses `matchMedia` so it reacts to orientation changes and DevTools
 * viewport resizing without the cost of a full resize listener. Cleans
 * up via `onScopeDispose` so component unmount removes the listener.
 */
const MOBILE_MEDIA_QUERY = '(max-width: 639px)'

export function useIsMobile(): Readonly<Ref<boolean>> {
  const mql = window.matchMedia(MOBILE_MEDIA_QUERY)
  const flag = ref(mql.matches)

  const handler = (event: MediaQueryListEvent): void => {
    flag.value = event.matches
  }
  mql.addEventListener('change', handler)
  onScopeDispose(() => mql.removeEventListener('change', handler))

  return readonly(flag)
}
